import image1 from '../../../shared/assets/photo/works/1.png';
import image2 from '../../../shared/assets/photo/works/2.png';
import image3 from '../../../shared/assets/photo/works/3.png';
import image4 from '../../../shared/assets/photo/works/4.png';
import image5 from '../../../shared/assets/photo/works/5.png';
import image6 from '../../../shared/assets/photo/works/6.png';
import image7 from '../../../shared/assets/photo/works/7.png';
import image8 from '../../../shared/assets/photo/works/8.png';
import image9 from '../../../shared/assets/photo/works/9.png';
import image10 from '../../../shared/assets/photo/works/10.png';
import image11 from '../../../shared/assets/photo/works/11.png';
import image12 from '../../../shared/assets/photo/works/12.png';


export const myWorksData = [
    {
        index:1,
        src: image1,
        text: 'история любви',
        btn:"/lovestory"
    },
    {
        index:2,
        src: image3,
        text: 'семья',
        btn:"/family"
    },

    {
        index:3,
        src: image5,
        text: 'мама и дочь',
        btn:"/daughter"  
    
    },
    {
        index:4,
        src: image7,
        text: 'крестины',
        btn:"/christ"
    },
    {
        index:5,
        src: image9,
        text: 'новорожденный',
        btn:"/newborn"
    },
    {
        index:6,
        src: image11,
        text: 'новый год',
        btn:"/newyear"
    },
    {
        index:7,
        src: image2,
        text: 'свадьба',
        btn:"/wedding"
    },
    {
        index:8,
        src: image4,
        text: 'дети',
        btn:"/kids"
    },
    {
        index:9,
        src: image6,
        text: 'женская',
        btn:"/woman"
    },
    {
        index:10,
        src: image8,
        text: 'в ожидании',
        btn:"/pregnancy"
    },
    {
        index:11,
        src: image10,
        text: 'зима',
        btn:"/winter"
    },    {
        index:12,
        src: image12,
        text: 'день рождения',
        btn:"/birthday"
    },
]